 function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());

  let productModel = document.querySelectorAll("product-model");
  if (productModel) {
    productModel.forEach((model) => model.modelViewerUI.pause());
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone") document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)));
    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById("shopify-section-header");
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    document.querySelectorAll(".product-media-modal__image").forEach((productImage) => {
      productImage.addEventListener("click", () => {
        this.hide();
      });
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");

    let templatePopup = this.querySelector(".template-popup");
    if (templatePopup) {
      templatePopup.loadContent();
    }

    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      console.log(modal.show('button'))
      if (modal) modal.show('button');
      
    });
  }
}
customElements.define("modal-opener", ModalOpener);


class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    let deferedPoster = this.querySelector('[id^="Deferred-Poster-"]');
    if (deferedPoster) {
      deferedPoster.addEventListener("click", this.loadContent.bind(this));
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector("video, model-viewer, iframe")).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);




function updateTabbingForNav() {
  const desktopNav = document.querySelector('.header__inline-menu');
  const isMobile = window.innerWidth <= 998;

  if (!desktopNav) {
    console.warn('[accessibility] Could not find .header__inline-menu');
    return;
  }

  console.log(`[accessibility] Viewport is ${window.innerWidth}px. Mobile: ${isMobile}`);

  const focusables = desktopNav.querySelectorAll('a, button, input, select, textarea, [tabindex]');

  focusables.forEach(el => {
    if (isMobile) {
      const prev = el.getAttribute('tabindex');
      el.setAttribute('data-prev-tabindex', prev ?? '');
      el.setAttribute('tabindex', '-1');
      el.setAttribute('aria-hidden', 'true'); // Just in case screen readers sneak in
      console.log('[accessibility] Hiding focusable:', el);
    } else {
      const prev = el.getAttribute('data-prev-tabindex');
      if (prev === '') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', prev);
      }
      el.removeAttribute('data-prev-tabindex');
      el.removeAttribute('aria-hidden');
      //console.log('[accessibility] Restoring focusable:', el);
    }
  });
}

// Run it once on load
//updateTabbingForNav();

// And again when the window is resized
window.addEventListener('resize', debounce(updateTabbingForNav, 200));

// Optional: simple debounce so it doesn't fire 100x/sec
function debounce(fn, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}








class GiftCardSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onGiftCardVariantChange);
  }

  onGiftCardVariantChange(e) {
    if (e.target.className === "gift__card__buttons") {
      this.updateSelectedGiftCard(e);
      this.updateOptions(e);
      this.updateMasterId();
      this.updateCartAndURL();
    }
  }

  updateSelectedGiftCard(e) {
    let hiddenSelectedValue = document.getElementById("current_default_value__giftcard");
    let allSizeButtons = document.querySelector(".select__giftcard__custom__wrapper").querySelectorAll("button");

    let newHiddenSelectedValue = e.target.getAttribute("value");
    hiddenSelectedValue.setAttribute("value", newHiddenSelectedValue);

    allSizeButtons.forEach((item) => {
      item.classList.remove("active--button");
      if (item.value === hiddenSelectedValue.getAttribute("value")) {
        item.classList.add("active--button");
      }
    });
  }

  updateOptions(e) {
    this.options = [e.target.value];
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)[1];
    return this.variantData;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.name.includes(this.options[0]) && variant.option1 == this.options[0];
    });
  }

  updateCartAndURL() {
    const cartForm = document.querySelector(".preorder-info-container > .product-form > .form").querySelector("input[name='id']");
    cartForm.value = this.currentVariant.id;
    window.history.replaceState({}, "", `?variant=${this.currentVariant.id}`);
  }
}

customElements.define("giftcard-variant-selects", GiftCardSelects);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onProductChange);
    this.addEventListener("click", this.onVariantChange);
  }

  onProductChange(e) {
    this.updateOptions(e);
    this.updateMasterId();
    this.updateMasterProduct();
    window.location.href = `${this.currentProduct.handle}?variant=${this.currentVariant.id}`;
  }

  onVariantChange(e) {
    if (e.target.parentElement.className === "select__shoesize__custom__wrapper") {
      this.getSelectedShoeSize(e);
      this.updateOptions();
      this.updateMasterId();
      this.updateInventoryQuantity();
      this.updateMasterProduct();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.updateSelectButtons();

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        // this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
      }
    }
  }

  updateSelectButtons() {
    let allButtons = document.querySelector(".select__shoesize__custom__wrapper").querySelectorAll("button");
    let size = document.querySelector("#current_default_value").getAttribute("value");
    document.getElementById("current-size-preview").innerHTML = size;
    allButtons.forEach((item) => {
      item.classList.remove("active--button");
      if (item.value === size) {
        item.classList.add("active--button");
      }
    });
  }

  getSelectedShoeSize(e) {
    let val = e.target.getAttribute("value");
    document.getElementById("current_default_value").setAttribute("value", val);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)[1];
    return this.variantData;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  getProductData() {
    if (JSON.parse(this.querySelector('[type="application/json"]').textContent)[0].title == undefined) {
      this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent)[0].map((product) => JSON.parse(product));
      return this.productData;
    } else if (JSON.parse(this.querySelector('[type="application/json"]').textContent)[0].title == "eGift Card") {
      var giftCardArray = [];
      var giftCardData = JSON.parse(this.querySelector('[type="application/json"]').textContent)[0];
      giftCardArray.push(giftCardData);
      this.productData = giftCardArray;
      return this.productData;
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      if (this.options[1]) {
        // this is for boots
        return variant.name.split(" - ")[1] == this.options[0] && variant.option1 == this.options[1];
      } else {
        // this is for belts, gift cards, etc.
        return variant.name.split(" - ")[1] == this.options[0] && variant.option1 == this.options[0];
      }
    });
  }

  updateMasterProduct() {
    this.currentProduct = this.getProductData().find((product) => {
      if (product.title.split(" - ")[1] == this.options[0]) {
        return product.variants.map((option) => {
          return option.id == this.currentVariant.id;
        });
      }
    });
  }

  updateInventoryQuantity() {
    if (this.currentVariant.inventory_quantity < 10 && this.currentVariant.inventory_quantity >= 3 && this.currentVariant.inventory_policy == "deny") {
      document.getElementById("current-inventory-preview").innerHTML = `Only ${this.currentVariant.inventory_quantity} left in stock!`;
    } else {
      document.getElementById("current-inventory-preview").innerHTML = "";
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    var color = this.currentVariant.option1;
    var variant_id = this.currentVariant.id;
    var variant_sku = this.currentVariant.sku;
    const newMedia = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, "", `${this.currentProduct.handle}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  toggleBuyButtonLoading(loading) {
    let btn = document.querySelector(".product-form__submit");
    if (btn && loading === true) {
      btn.classList.add("loading");
      btn.disabled = true;
    }
    if (btn && loading === false) {
      btn.classList.remove("loading");
      btn.disabled = false;
    }
  }

  renderProductInfo() {
    this.toggleBuyButtonLoading(true);
    fetch(`${this.currentProduct.handle}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        const destination_header = document.getElementsByClassName("product__title")[0];
        const header = html.getElementsByClassName("product__title")[0];
        if (destination_header && header) destination_header.innerHTML = header.innerHTML;

        // const image_destination = document.getElementsByClassName('main__product__media__wrapper__target')[0]
        // const image_source = html.getElementsByClassName('main__product__media__wrapper__target')[0]
        // if (image_destination && image_source) image_destination.innerHTML = image_source.innerHTML

        const preorder_destination = document.getElementsByClassName("preorder-info-container")[0];
        const preorder_source = html.getElementsByClassName("preorder-info-container")[0];
        if (preorder_destination && preorder_source) preorder_destination.innerHTML = preorder_source.innerHTML;

        if (source && destination) destination.innerHTML = source.innerHTML;

        let priceDataSection = document.getElementById(`price-${this.dataset.section}`);
        if (priceDataSection) {
          priceDataSection.classList.remove("visibility-hidden");
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        var color_selected = $("input[type='radio']:checked").val();
        $("#product__color_name").html(color_selected);

        this.toggleBuyButtonLoading(false);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButtonOriginal = document.getElementById(`product-form-${this.dataset.section}`);
    let addButton;

    if (addButton) {
      addButton = addButtonOriginal.querySelector('[name="add"]');
    }

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      // New - added backorder to button rendering
      var inventory_quantity = $(addButton).data("inventory");
      var inventory_policy = $(addButton).data("policy");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButtonOriginal = document.getElementById(`product-form-${this.dataset.section}`);
    let addButton;

    if (addButton) {
      addButton = addButtonOriginal.querySelector('[name="add"]');
    }

    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;

    let setUnavailablePriceSection = document.getElementById(`price-${this.dataset.section}`);
    if (setUnavailablePriceSection) {
      setUnavailablePriceSection.classList.add("visibility-hidden");
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ColorSwatches extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    // var size = this.querySelector('select').value
    var size = document.querySelector("#current_default_value").getAttribute("value");
    var fieldset = this.querySelector("fieldset");
    var color = Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    this.options = [color, size];
  }
}

customElements.define("color-swatches", ColorSwatches);

// class SoldOut extends HTMLElement {
//   constructor(){
//     super();
//     this.querySelector('form').addEventListener('submit', this.onSoldOutSubmit.bind(this))
//   }

//   onSoldOutSubmit(event) {
//     event.preventDefault()
//     let email = this.querySelector('#email-input').value;
//     let variantId = this.querySelector('#email-input').dataset.variant;// selectedVariant.id; //global variable set on selectCallback
//     let notifyType = 'backordered';

//     $.ajax({
//       url: `https://${hostName()}.herokuapp.com/api/v2/variant_notifications`,
//       type: 'POST',
//       data: {email: email, shopify_variant_id: variantId, notification_type: notifyType},
//       success: function (response){
//         document.querySelector('#sold-out-notification').innerHTML = "<span style='color:green; font-weight: bold; font-family: \"Montserrat\", sans-serif; font-size:18px; text-transform: uppercase;'>You're all set!</span><br />You will be notified by email when it arrives.";
//       },
//       error: function (response){
//         document.querySelector('#sold-out-notification').innerHTML = 'There was a problem saving your selection, please try again.'
//       }
//     });
//   }

// }

// customElements.define('sold-out', SoldOut);

$(document).on("click", ".add-to-favorites", function () {
  if ($(this).data("setting") == "no-customer") {
    openLoginRegisterModal("signin-modal");
  } else {
    var customer = $(this).data("setting");
    var variant = $(this).data("variant");
    var setMethod = "add";

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(".add-to-favorites-heart").removeClass("active");
      $(".add-to-favorites-heart-mobile").removeClass("active");

      setMethod = "remove";
    } else {
      $(this).addClass("active");
      $(".add-to-favorites-heart").addClass("active");
      $(".add-to-favorites-heart-mobile").addClass("active");

      setMethod = "add";
    }

    var fdata = { customer: customer, variant: variant, setmethod: setMethod };
    // fire off ajax request to add to table after migrating product id's`
    $.ajax({
      url: `https://freebird-customer-api.herokuapp.com/api/v1/set_favorite`,
      // url: `https://${hostName()}.herokuapp.com/api/v2/set_favorite`,
      type: "POST",
      dataType: "json",
      data: fdata,
      crossDomain: true,
      success: function (data) {
        var favorite_items = data.favorites;
        var i;
        for (i = 0; i < favorite_items.length; i++) {
          var item = $('.add-to-favorites[data-product="' + favorite_items[i]["shopify_product_id"] + '"]');
          item.addClass("active");
        }
      },
      error: function (data) {
      },
    });
  }
});

$(document).ready(function(){
  // -----------------------------------------------------------
  // GA Events
  // -----------------------------------------------------------
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#eventCategory
  // -----------------------------------------------------------
  // Forgot Password
  $('a.forgot-password').on('click', function(){
    ga('send', 'event', {
      'eventCategory': 'Account Mgmt',
      'eventAction': 'Forgot Password'
    });
  });
  // OAuth Sign-In
  $('.oauth-btn').on('click', function(){
    ga('send', 'event', {
      'eventCategory': 'Account Mgmt',
      'eventAction': 'User Sign-In',
      'eventLabel': 'OAuth Account'
    });
  });
  // Add to Wishlist
  $('.add-to-wish-list-link').on('click', function(){
    let user_email = $(this).data('setting');
    let variant_id = $(this).data('variant');
    if (user_email.length > 0) {
      ga('send', 'event', {
        'eventCategory': 'Account Mgmt',
        'eventAction': 'Add to Wishlist',
        'eventLabel': variant_id
      });
    }
  });

  $('.product-form__submit').on('click', function(){
    let variant_id = $('input[name=id]').val();
    ga('send', 'event', {
      'eventCategory': 'Checkout Behaviors',
      'eventAction': 'Add to Cart',
      'eventLabel': variant_id
    });

  });


  $('.cart__checkout-button').on('click', function(){
    ga('send', 'event', {
      'eventCategory': 'Checkout Behaviors',
      'eventAction': 'Start Checkout',
      'eventLabel': 'Product Detail'
    });
  });

  $('.fblr-checkout-button').on('click', function(){
    ga('send', 'event', {
      'eventCategory': 'Checkout Behaviors',
      'eventAction': 'Start Checkout',
      'eventLabel': 'Toast Popup'
    });
  });

  // $('#gorgias-chat-messenger-button').on('click', function(){
  //   let closeWindow = $(this).attr('aria-label');
  //   ga('send', 'event', {
  //     'eventCategory': 'Customer Service',
  //     'eventAction': 'Initiate CS Widget'
  //   });
  // });

  $('#conversation').on('focus', function(){
    ga('send', 'event', {
      'eventCategory': 'Customer Service',
      'eventAction': 'Engage with CS Widget'
    });
  });

  $('input[type=email]').on('blur', function(){
  });

});

function hostName() {
  let url_string = window.location.href;
  let url = new URL(url_string);
  let hostname = url.hostname;
  if (hostname === "freebird-staging.myshopify.com") {
    return "freebirdstores-shopify";
  } else {
    return "freebirdstores";
  }
}